import { MicroFrontend } from '@praxis/component-microfrontend'
import apiConfig from '../../globalConfig/apiConfig'
import { LoadingProfileMfe } from '../common/LoadingProfileMfe'

export const useUploadHistory = ({
  historyRefreshKey = 0,
  mfeReloadKey = 0,
  ...restProps
} = {}) => {
  const path = `${apiConfig.remotes.bulkX}/remoteEntry.js`

  const uploadHistoryMfe = (
    <MicroFrontend
      // Keep key values owned by the parent so upload success can remount history.
      key={`${historyRefreshKey}-${mfeReloadKey}`}
      module="./uploadHistoryStandard"
      src={path}
      anyProp={'any value'}
      Loading={LoadingProfileMfe}
      isEmbedded={true}
      {...restProps}
    />
  )

  return { uploadHistoryMfe }
}
